import React from 'react'
import { useTheme } from '@/context/ThemeContext'

type Props = { label?: string; onClick?: () => void; fullWidth?: boolean; disabled?: boolean }

const SaveBtn: React.FC<Props> = ({ label = 'Save changes', onClick, fullWidth = false, disabled = false }) => {
  const { currentTheme: t } = useTheme()
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={
        (fullWidth
          ? 'w-full h-11 rounded-lg text-sm font-semibold text-white transition-opacity hover:opacity-90'
          : 'h-10 px-5 rounded-full text-[13.5px] font-semibold text-white transition-opacity hover:opacity-90')
        + ' disabled:cursor-not-allowed disabled:opacity-60'
      }
      style={{ background: t.accentGradient, boxShadow: '0 1px 6px rgba(79,70,229,0.25)' }}
    >
      {label}
    </button>
  )
}

export default React.memo(SaveBtn)
